import React, { useRef, useEffect } from 'react';
import { map } from 'lodash';
import CmsButtons from '../../services/cms/CmsButtons';
import generateStyle from '../../services/cms/CmsButtonsStyle';
import './ButtonGroup.scss';

const ButtonGroup = ({ buttonsList, orientation, alignment }) => {
    const itemsRef = useRef([]);
    const adjustColor = function (color, amount) {
        return (
            '#' +
            color
                .replace(/^#/, '')
                .replace(/../g, (color) =>
                    (
                        '0' +
                        Math.min(
                            255,
                            Math.max(0, parseInt(color, 16) + amount)
                        ).toString(16)
                    ).substr(-2)
                )
        );
    };
    // function LightenDarkenColor(col, amt) {
    //     var usePound = false;

    //     if (col[0] == '#') {
    //         col = col.slice(1);
    //         usePound = true;
    //     }

    //     var num = parseInt(col, 16);

    //     var r = (num >> 16) + amt;

    //     if (r > 255) r = 255;
    //     else if (r < 0) r = 0;

    //     var b = ((num >> 8) & 0x00ff) + amt;

    //     if (b > 255) b = 255;
    //     else if (b < 0) b = 0;

    //     var g = (num & 0x0000ff) + amt;

    //     if (g > 255) g = 255;
    //     else if (g < 0) g = 0;

    //     return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
    // }
    useEffect(() => {
        itemsRef.current = itemsRef.current.slice(0, buttonsList.length);
    }, [buttonsList]);

    const buttons = map(buttonsList, (b, idx) => {
        const fallbacksToDefault =
            b.backgroundColorHex === null || b.textColorHex === null;
        if (fallbacksToDefault) {
            return (
                <button
                    className='button button--primary'
                    key={idx}
                    onClick={(e) => {
                        itemsRef.current[idx].click();
                    }}>
                    {b.text}
                    <a
                        ref={(el) => (itemsRef.current[idx] = el)}
                        href={b.link}
                        target={b.target}
                        style={{
                            width: '0px',
                            height: '0px',
                            padding: '0px',
                            display: 'none',
                        }}></a>
                </button>
            );
        }
        return (
            <a
                key={idx}
                ref={(el) => (itemsRef.current[idx] = el)}
                href={b.link}
                target={b.target}
                style={{
                    backgroundColor: b.backgroundColorHex,
                    color: b.textColorHex,
                    borderRadius: '2px',
                    lineHeight: '48px',
                }}
                onMouseEnter={() => {
                    itemsRef.current[idx].style.filter = 'brightness(90%)';
                }}
                onMouseLeave={() => {
                    itemsRef.current[idx].style.filter = 'brightness(100%)';
                }}>
                {b.text}
            </a>
        );
    });

    return (
        <div
            className={`button-group ${
                orientation === CmsButtons.orientation.row ? 'row' : 'column'
            }`}
            style={generateStyle(alignment, orientation)}>
            {buttons}
        </div>
    );
};

export default ButtonGroup;
